module.exports = __webpack_public_path__ + "img/puzzle_button.422b43fa.svg";